// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1bah1h6o{justify-content:center}\n._1e0c1txw{display:flex}\n._1ul98pqr{min-width:2.5rem}\n._o5721q9c{white-space:nowrap}", ""]);
// Exports
module.exports = exports;
